import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { UiIconStatusComponent } from '@uigy/shared/components/icons/ui-icon-status/ui-icon-status.component';
import { StatusIconType } from '@uigy/shared/components/icons/interfaces';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import Utils from '@uigy/utils';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
    selector: 'app-kpi-main',
    imports: [
        UiIconStatusComponent,
        MatTooltip,
        MatRippleModule,
        NgClass,
    ],
    templateUrl: './kpi-main.component.html',
    styleUrl: './kpi-main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiMainComponent {
  public isLoading = input<boolean>(false);
  public count = input.required<number | string>();
  public title = input.required<string>();
  public subTitle = input.required<string>();
  public status = input.required<StatusIconType>();
  public tooltip = input<string>();
  public isClickable = input<boolean>(true);
  public clicked = output<void>();
  protected readonly Utils = Utils;
  protected readonly languageService = inject(LanguageService);
}
